import { makeActionCreator } from '../../../utilities'
import { ScrollToTopConstants } from './scrollToTop.constants'

export const toggleScrollToTop = makeActionCreator(ScrollToTopConstants.SET_IS_VISIBLE, 'currentY')

export const setScrollTargetID = makeActionCreator(ScrollToTopConstants.SET_SCROLL_TARGET_ID, 'scrollTargetID')
